import React from 'react';
import classNames from 'classnames';

const Banner = ({data, type, islogin})=> {
    let messages = [];
    return (
        <div className={classNames("banner col-1 z-100 psticky t-0", {})}>
            {(data.length > 0) &&
            (data || []).map((title, index) => {
                messages.push(title.message)
            })}
            <marquee width="100%" direction="left" height="18px">
                <div className="fs-16 fBolder">{messages.join(' | ')}</div>
            </marquee>
        </div>
    )
}

export default Banner;
